<template>
    <v-row no-gutters class="pt-2" :style="{ paddingLeft: filtersVisible ? '0px' : '10px' }">
        <v-col>
            <v-card>
                <v-card-text>
                    <v-skeleton-loader type="image" :boilerplate="!dataLoading" v-if="showSkeleton" height="350px" />

                    <highcharts v-else ref="timelineChart" :options="timelineChartOptions"></highcharts>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>
<script>
import { Chart } from "highcharts-vue";
import { mapMutations, mapState, mapActions, mapGetters } from "vuex";
import { workOrderMixin } from "@/mixins/work-order-mixin";

export default {
    name: "timeline-chart-row",
    mixins: [workOrderMixin],
    components: {
        highcharts: Chart,
    },
    watch: {
        filtersVisible() {
            this.$nextTick(() => {
                if (this.$refs.timelineChart) {
                    this.$refs.timelineChart.chart.reflow();
                }
            });
        },
    },
    data() {
        return {};
    },
    mounted() {
        setTimeout(() => {
            if (this.$refs.timelineChart && this.$refs.timelineChart.chart) {
                this.$refs.timelineChart.chart.reflow();
            }
        }, 100);
    },
    methods: {
        ...mapActions("ProductionAnalysisStore", []),
        ...mapMutations("ProductionAnalysisStore", []),
    },
    computed: {
        ...mapState("ProductionAnalysisStore", ["chartOptions", "filtersVisible", "dataLoading", "showSkeleton", "timelineChartOptions"]),
    },
};
</script>
<style scoped>
::v-deep .v-skeleton-loader__image {
    height: 100%;
}

::v-deep .highcharts-credits {
    display: none;
}
</style>
